// In a type: module package non-ts files won't be interpreted properly if they
// don't have imports or exports.
export { }

const checkoutEl = document.getElementById('gsg-checkout')
const siteEl = document.getElementById('site')
const cartIdEl = document.getElementById('cart-id')
const widgetPlaceholderEl = document.getElementById('widget-placeholder')
const widgetWrapperEl = document.getElementById('widget-wrapper')
const alertModal = document.getElementById('widget-alert')
const closeAlertButton = alertModal.querySelector('.close')
const alertMessage = document.getElementById('alert-message')
const envEl = document.getElementById('env')

main()

function main () {
  initForm()

  closeAlertButton.onclick = function (event) {
    event.preventDefault()
    hideModal(alertModal)
  }
}

// Replaces the contents of any .widget-inject-environment elements in the DOM
// with the current environment
function injectEnvironment (environment) {
  const elements = document.getElementsByClassName('widget-inject-environment')
  for (let i = 0; i < elements.length; i++) {
    elements[i].innerText = environment
  }
}

function initForm () {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  })

  // Now grab the env value
  const envParam = params.env
  if (envParam && (envParam === 'demo' || envParam === 'beta')) {
    envEl.value = envParam
    envEl.disabled = true
  }

  const attachForm = document.getElementById('widget-attach-form')
  attachForm.addEventListener('submit', function (event) {
    event.preventDefault()

    loadWidget()
  })
}

function loadWidget () {
  const site = siteEl.value
  const cartId = cartIdEl.value
  const environment = envEl.value

  injectEnvironment(environment)

  widgetPlaceholderEl.className = 'd-none' // hide the placeholder
  widgetWrapperEl.className = '' // un-hide the widget wrapper
  checkoutEl.innerHTML = '<em>Loading...</em>'

  // eslint-disable-next-line no-undef
  CheckoutWidget.attach('#gsg-checkout', {
    site,
    environment,
    cartId,
    language: 'en',

    onSuccess: function () {
      showAlert('Payment complete')
    },

    onCancel: function () {
      showAlert('Payment canceled')
    },

    onError: function (error) {
      showAlert(error.message)
    },
  })
}

function showModal (modalEl) {
  modalEl.className = modalEl.className.split(' ')
    .map(name => name === 'closed' ? 'open' : name).join(' ')
}

function hideModal (modalEl) {
  modalEl.className = modalEl.className.split(' ')
    .map(name => name === 'open' ? 'closed' : name).join(' ')
}

function showAlert (message) {
  alertMessage.innerText = message
  showModal(alertModal)
}

window.showAlert = showAlert
